var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import { loadGlobalProperties } from '@popup/steem/actions/global-properties.actions'; // ← AGGIUNGI QUESTO
import { useDispatch } from 'react-redux';
const CHAINS = [
    { key: "STEEM", name: "Steem", icon: SVGIcons.WALLET_STEEM_LOGO },
    { key: "HIVE", name: "Hive", icon: SVGIcons.WALLET_HIVE_LOGO },
    { key: "BLURT", name: "Blurt", icon: SVGIcons.WALLET_BLURT_LOGO },
    { key: "TIME", name: "Time", icon: SVGIcons.WALLET_TIME_LOGO },
];
export const BlockchainSwitcherComponent = () => {
    const dispatch = useDispatch();
    const [activeChain, setActiveChain] = useState("STEEM");
    const [isOpen, setIsOpen] = useState(false);
    const [rotateLogo, setRotateLogo] = useState(false);
    useEffect(() => {
        LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN)
            .then((saved) => {
            if (!saved)
                return;
            const clean = String(saved).replace(/^"|"$/g, '').trim().toUpperCase();
            if (["STEEM", "HIVE", "BLURT", "TIME"].includes(clean)) {
                setActiveChain(clean);
            }
        })
            .catch(() => { });
    }, []);
    const selectChain = (chainKey) => __awaiter(void 0, void 0, void 0, function* () {
        const upperKey = chainKey.toUpperCase();
        setActiveChain(upperKey);
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN, upperKey);
        setRotateLogo(true);
        // FORZA REFRESH COMPLETO: ricarica account + global properties
        dispatch(refreshActiveAccount());
        dispatch(loadGlobalProperties()); // ← QUESTO È IL TRUCCO MAGICO
        setTimeout(() => setRotateLogo(false), 1000);
        setIsOpen(false);
    });
    const current = CHAINS.find(c => c.key === activeChain) || CHAINS[0];
    return (React.createElement("div", { className: "blockchain-switcher", onClick: () => setIsOpen(!isOpen) },
        React.createElement(SVGIcon, { icon: current.icon, className: `chain-icon ${rotateLogo ? 'rotate' : ''}` }),
        React.createElement("span", { className: "chain-name" }, current.name),
        React.createElement("svg", { className: `dropdown-arrow ${isOpen ? 'open' : ''}`, viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M7 10l5 5 5-5z", fill: "currentColor" })),
        isOpen && (React.createElement("div", { className: "dropdown-menu", onClick: (e) => e.stopPropagation() }, CHAINS.map((chain) => (React.createElement("div", { key: chain.key, className: `dropdown-item ${chain.key === activeChain ? 'active' : ''}`, onClick: () => selectChain(chain.key) },
            React.createElement(SVGIcon, { icon: chain.icon, className: "item-icon" }),
            React.createElement("span", null, chain.name),
            chain.key === activeChain && React.createElement("span", { className: "check" }, "\u2713"))))))));
};
